import { render, staticRenderFns } from "./OutProcessingPackageEmailComponent.vue?vue&type=template&id=fff4996e&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fff4996e')) {
      api.createRecord('fff4996e', component.options)
    } else {
      api.reload('fff4996e', component.options)
    }
    module.hot.accept("./OutProcessingPackageEmailComponent.vue?vue&type=template&id=fff4996e&", function () {
      api.rerender('fff4996e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Email/OutProcessingPackageEmailComponent.vue"
export default component.exports